import { useQuery } from '@tanstack/react-query'
import { fetchReapproAlgorithmParams } from '../queries/reapproAlgorithms.queries'

export const useReapproAlgorithmParams = () =>
  useQuery({
    queryKey: ['reapproAlgorithmParams'],
    queryFn: fetchReapproAlgorithmParams,
  })
